import { BASE_API_URL } from "../../config/Api";
import { ADD_LEAVE_BALANCE, CREATE_LEAVE, LEAVE_APPROVE, LEAVE_APPROVE_LIST, LEAVE_APPROVE_LIST_DATEWISE, LEAVE_BALANCE, LEAVE_BALANCE_ALL, LEAVE_BALANCE_LIST, LEAVE_CANCEL, LEAVE_LIST, LEAVE_TYPE, LEAVE_APPROVED_LIST_BY_ID_YEAR, LEAVE_LIST_BY_YEAR, LEAVE_SUMMARY, CREATE_PASSOUT, PASSOUT_SUMMARY, PASSOUT_DETAILS } from "./ActionType";

export const getLeaveTypeList=(token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/leaveType`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:LEAVE_TYPE, payload:resData})
    } catch (error) {
        
    }
}

export const getLeaveBalanceList=(token,loginId,type)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/leaveBalance?loginId=${loginId}`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        if(type === 'Apply'){
            dispatch({type:LEAVE_BALANCE, payload:resData})
        }else{
            dispatch({type:LEAVE_BALANCE_LIST, payload:resData})
        }
    } catch (error) {
        
    }
}

export const getLeaveList=(token,loginId)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/leaveList?loginId=${loginId}`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:LEAVE_LIST, payload:resData})
    } catch (error) {
        
    }
}

export const createLeave=(token,leaveData)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/createLeave`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(leaveData),
        })
        const resData=await res.json();
        if (res.ok) {
            dispatch({ type: CREATE_LEAVE, payload: resData });
            return resData;
        } else {
            throw new Error(resData.statusDesc || 'Unknown error occurred');
        }
    } catch (error) {
         console.error("Error:", error);
    }
}

export const getLeaveApproveList=(token,loginId)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/leaveApproveList?managerId=${loginId}`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:LEAVE_APPROVE_LIST, payload:resData})
    } catch (error) {
        
    }
}

export const approveLeave=(approverId,leaveId,status,token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/approveLeave?approverId=${approverId}&leaveId=${leaveId}&status=${status}`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        if (res.ok) {
            dispatch({ type: LEAVE_APPROVE, payload: resData });
            return resData;
        } else {
            throw new Error(resData.statusDesc || 'Unknown error occurred');
        }
    } catch (error) {
         console.error("Error:", error);
    }
}

export const getLeaveApproveListDatewise=(loginId,startDate,endDate,token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/leaveListDateWise?loginId=${loginId}&startDate=${startDate}&endDate=${endDate}`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:LEAVE_APPROVE_LIST_DATEWISE, payload:resData})
    } catch (error) {
        
    }
}


export const cancelLeave=(leaveId,token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/cancelLeave?leaveId=${leaveId}`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        if (res.ok) {
            dispatch({ type: LEAVE_CANCEL, payload: resData });
            return resData;
        } else {
            throw new Error(resData.statusDesc || 'Unknown error occurred');
        }
    } catch (error) {
         console.error("Error:", error);
    }
}

export const getAllLeaveBalanceList=(token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/fetchAllLeaveBalance`,{
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:LEAVE_BALANCE_ALL, payload:resData})
    } catch (error) {
        
    }
}

export const addLeaveBalance=(token,leaveData)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/addLeaveBalance`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(leaveData),
        })
        const resData=await res.json();
        if (res.ok) {
            dispatch({ type: ADD_LEAVE_BALANCE, payload: resData });
            return resData;
        } else {
            throw new Error(resData.statusDesc || 'Unknown error occurred');
        }
    } catch (error) {
         console.error("Error:", error);
    }
}

export const getApprovedListByIdAndDateRange=(loginId,fromDate,toDate,token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/leaveApprovedListbyIdAndDateRange?loginId=${loginId}&fromDate=${fromDate}&toDate=${toDate}`,{
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:LEAVE_APPROVED_LIST_BY_ID_YEAR, payload:resData})
    } catch (error) {
        
    }
}

export const getLeaveListByYear = (token, loginId, year) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/leaveListByYear?loginId=${loginId}&year=${year}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const resData = await res.json();
    dispatch({ type: LEAVE_LIST_BY_YEAR, payload: resData });
  } catch (error) {
    console.error("Error fetching leave list by year:", error);
  }
};

export const getLeaveSummary = (token, year) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/leaveSummary?year=${year}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const resData = await res.json();
    dispatch({ type: LEAVE_SUMMARY, payload: resData });
  } catch (error) {
    console.error("Error fetching leave list by year:", error);
  }
};

export const createPassout = (token, passOutData) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/createPassout`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(passOutData),
        })
        const resData = await res.json();
        if (res.ok) {
            dispatch({ type: CREATE_PASSOUT, payload: resData });
            return resData;
        } else {
            throw new Error(resData.statusDesc || 'Unknown error occurred');
        }
    } catch (error) {
        console.error("Error:", error);
    }
}

export const getPassOutSummary = (token, year, loginId) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/passOutSummary?year=${year}&loginId=${loginId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const resData = await res.json();
    dispatch({ type: PASSOUT_SUMMARY, payload: resData });
  } catch (error) {
    console.error("Error fetching pass out list by year:", error);
  }
};

export const getPassOutDetails = (token, passOutId) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/passOutById?passOutId=${passOutId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const resData = await res.json();
    dispatch({ type: PASSOUT_DETAILS, payload: resData });
  } catch (error) {
    console.error("Error fetching pass out  details by year and id:", error);
  }
}
